import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { freeSet as icons } from '@coreui/icons'
import { createHead } from '@vueuse/head'
import { captureAttributionFromUrl } from './utils/attribution'

const head = createHead()

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.use(head)

app.config.globalProperties.mainLogo =
  'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:eco,w_100/v1678425799/mchanga-fine-logo_fkytym.png'
app.config.globalProperties.facebookLink =
  'https://www.facebook.com/ChangaAfrica'
app.config.globalProperties.twitterLink = 'https://twitter.com/m_changa'
app.config.globalProperties.youtubeLink =
  'https://www.youtube.com/channel/UCo8LCOVJmzJb_5fTikHbXeA'
app.config.globalProperties.linkedinLink =
  'https://www.linkedin.com/company/mobi-changa-limited'
app.config.globalProperties.instagramLink =
  'https://www.instagram.com/m_changa_kenya/'
app.config.globalProperties.supportPhone = '+254207650919'
app.config.globalProperties.supportMobilePhone = '+254711082582'
app.config.globalProperties.supportEmail = 'support@mchanga.africa'
app.config.globalProperties.defaultShareImage =
  'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto/v1492603822/commonshare/mchangawide.png'
app.config.globalProperties.mchangaPAYBILL = '891300'
app.config.globalProperties.airtelBusinessName = 'MCHANGA'
app.config.globalProperties.baseURL = process.env.VUE_APP_BASE_URL
app.config.globalProperties.apiURL = process.env.VUE_APP_ROOT_API
app.config.globalProperties.webURL = process.env.VUE_APP_WEB_URL
app.config.globalProperties.recaptchaSiteKey =
  process.env.VUE_APP_RECAPTCHA_SITE_KEY
app.config.globalProperties.allowed_country_codes = [
  '254',
  '256',
  '233',
  '221',
  '226',
  '227',
  '234',
  '255',
  '225',
  '260',
  '228',
  '229',
  '241',
]
app.config.globalProperties.available_countries = [
  'KE',
  'UG',
  'GH',
  'SN',
  'BF',
  'NE',
  'NG',
  'TZ',
  'CI',
  'ZM',
  'GA',
  'TG',
  'BJ',
]
app.config.globalProperties.local_country_codes = {
  SN: '221',
  BF: '226',
  NE: '227',
  NG: '234',
  TZ: '255',
  UG: '256',
  CI: '225',
  ZM: '260',
  TG: '228',
  GA: '241',
  BJ: '229',
}
app.config.globalProperties.minimum_cashout = {
  KES: 250,
  XOF: 15000,
  NGN: 600000,
  UGX: 30000,
  GHS: 250,
  TZS: 75000,
  ZMW: 10000,
  XAF: 15000,
}
app.config.globalProperties.minimum_eft_cashout = {
  KES: 2000,
  XOF: 15000,
  NGN: 600000,
  UGX: 500000,
  GHS: 250,
  TZS: 75000,
  ZMW: 10000,
  XAF: 15000,
}
app.config.globalProperties.email_key =
  '546TCFGH4D6F8T7Y8DR64_45DFG5DF7@_GDRRRRTD64FGDF54GH8D6'
app.config.globalProperties.flutter_currency_codes = [
  'GHS',
  'UGX',
  'NGN',
  'TZS',
  'XOF',
  'ZMW',
  'XAF',
]
app.config.globalProperties.xaf_msisdn = '+221785976920'
app.config.globalProperties.country_flag = {
  KE: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/kenya.png',
  SN: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/senegal.png',
  BF: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/burkina.png',
  NE: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/niger.png',
  GH: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/ghana.png',
  NG: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664437758/web/nigeria.png',
  UG: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1664452350/web/uganda.png',
  TZ: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1688114675/OTHERS_LOGOS/tanzania.png',
  CI: 'https://res.cloudinary.com/changa/image/upload/c_thumb,f_auto,q_auto:low,w_50/v1693203168/OTHERS_LOGOS/CI.png',
}

// Capture on initial load (direct ad landing)
captureAttributionFromUrl(window.location.href)
// on all route changes
router.afterEach(() => {
  captureAttributionFromUrl(window.location.href)
})

app.mount('#app')
